import React, { useState, useMemo } from 'react';
import NotificationDropdown from './NotificationDropdown';
import { useNotifications } from '../utils/NotificationContext';

const Topbar = ({ title, subtitle }) => {
  const [showNotifications, setShowNotifications] = useState(false);
  const { notificationCount, recentNotifications } = useNotifications();

  const shouldBlink = (notificationCount?.unviewed || 0) > 0;
  console.log('Topbar: notificationCount:', notificationCount, 'shouldBlink:', shouldBlink);

  // badgeCount: number shown on the badge — authoritative from server counts
  const badgeCount = useMemo(() => {
    return Math.max(
      notificationCount?.unviewed || 0,
      notificationCount?.unread || 0
    );
  }, [notificationCount]);

  return (
    <>
      <div className="topbar">
        <div>
          <div className="page-title">{title}</div>
          {subtitle && <div className="page-sub">{subtitle}</div>}
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <style>{`
            @keyframes notif-ping {
              0% { transform: scale(1); opacity: 1; }
              75% { transform: scale(2.2); opacity: 0; }
              100% { transform: scale(2.2); opacity: 0; }
            }
            @keyframes notif-dot-pulse {
              0%, 100% { opacity: 1; }
              50% { opacity: 0.2; }
            }
            .notif-ping-ring {
              animation: notif-ping 1.2s cubic-bezier(0, 0, 0.2, 1) infinite;
            }
            .notif-dot-pulse {
              animation: notif-dot-pulse 1.2s ease-in-out infinite;
            }
          `}</style>
          <button
            className="topbar-btn"
            onClick={() => setShowNotifications(!showNotifications)}
            style={{ cursor: 'pointer', position: 'relative', overflow: 'visible', width: 'fit-content' }}
            aria-label={badgeCount > 0 ? `${badgeCount} unseen notifications` : 'Notifications'}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="var(--grey)" strokeWidth="1.8" strokeLinecap="round">
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9M13.73 21a2 2 0 0 1-3.46 0"/>
            </svg>

            {/* Unseen indicator: pulsing red dot with ping ring */}
            {shouldBlink && (
              <span
                style={{
                  position: 'absolute',
                  top: -3,
                  right: -3,
                  width: 10,
                  height: 10,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  zIndex: 9999
                }}
              >
                {/* Ping ripple ring */}
                <span
                  className="notif-ping-ring"
                  style={{
                    position: 'absolute',
                    inset: 0,
                    borderRadius: '50%',
                    background: '#FF5C5C',
                    opacity: 0.9
                  }}
                />
                {/* Solid red dot */}
                <span
                  className="notif-dot-pulse"
                  style={{
                    position: 'relative',
                    width: 10,
                    height: 10,
                    borderRadius: '50%',
                    background: '#FF5C5C',
                    border: '1.5px solid white',
                    display: 'block',
                    boxShadow: '0 0 6px rgba(255, 92, 92, 0.8)'
                  }}
                />
              </span>
            )}

            {/* Static count badge when all are seen but some are unread */}
            {!shouldBlink && badgeCount > 0 && (
              <div
                style={{
                  position: 'absolute',
                  top: -6,
                  right: -6,
                  minWidth: badgeCount > 9 ? 20 : 18,
                  height: 18,
                  padding: badgeCount > 9 ? '0 4px' : 0,
                  borderRadius: 999,
                  background: '#FF5C5C',
                  border: '2px solid white',
                  boxShadow: '0 0 8px rgba(255, 92, 92, 0.8)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: 10,
                  fontWeight: 700,
                  color: 'white',
                  lineHeight: 1,
                  zIndex: 9999
                }}
              >
                {badgeCount > 9 ? '9+' : badgeCount}
              </div>
            )}
          </button>
        </div>
      </div>
      <NotificationDropdown isOpen={showNotifications} onClose={() => setShowNotifications(false)} />
    </>
  );
};

export default Topbar;
